
<div class="store-setup-v2-page">
<p-toast position="bottom-center"></p-toast>

<div *ngIf="isLoadingStepStatus" class="loading-overlay">
    <div class="loading-spinner-container">
        <div class="spinner-circle">
            <i class="pi pi-spin pi-spinner"></i>
        </div>
        <p class="loading-text">Processing...</p>
    </div>
</div>

<div class="widget-wrapper font-family-system">
    <div
        class="onboarding-card"
        [style.opacity]="isLoadingStepStatus ? 0.5 : 1"
        [style.pointerEvents]="isLoadingStepStatus ? 'none' : 'auto'"
    >
        <div *ngIf="!isSuccess" class="fade-in">
            <div class="card-header">
                <div class="header-row">
                    <h3 class="header-title">Setup Guide</h3>
                    <span class="header-count"
                        >{{ completedSteps.size }} of {{ totalSteps }}
                        Completed</span
                    >
                </div>
                <p-progressBar
                    [value]="progressPercent"
                    [showValue]="false"
                    styleClass="custom-progress"
                ></p-progressBar>
            </div>

            <p-accordion
                *ngIf="isInitializationComplete"
                [(activeIndex)]="activeIndex"
                styleClass="custom-accordion"
                (onOpen)="onAccordionOpen($event)"
                (onClose)="onAccordionClose($event)"
            >
                <p-accordionTab [disabled]="!canOpenStep(1)" *ngIf="showBusinessDetails">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(1)"
                                >
                                    <i
                                        *ngIf="isStepCompleted(1)"
                                        class="pi pi-check"
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(1)"
                                    >Tell us about your business</span
                                >
                            </div>
                        </div>
                    </ng-template>

                    <div class="step-content-inner">
                        <p class="helper-text">
                            Tell us about your business and where it's located.
                        </p>

                        <form [formGroup]="businessDetailsForm">
                            <div class="form-group">
                                <label class="form-label"
                                    >Business Name
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="Enter your business name"
                                    formControlName="businessName"
                                    [readonly]="isStepCompleted(1)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessName')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessName')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business name is required
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Business Logo</label>
                                <p class="helper-text-small">
                                    Recommended size: 1:1 (500x500).
                                    Supported formats: JPG, PNG,
                                            GIF, BMP, SVG, AVIF.
                                    Maximum file size: 5MB.
                                </p>
                                <div
                                    *ngIf="!logoPreview && !isStepCompleted(1)"
                                    class="upload-btn-wrapper"
                                >
                                    <button
                                        type="button"
                                        class="btn-upload"
                                        (click)="logoFileInput.click()"
                                    >
                                        <i class="pi pi-upload"></i>
                                        Upload Logo
                                    </button>
                                    <input
                                        #logoFileInput
                                        type="file"
                                       accept=".png,.jpg,.jpeg,.webp,.gif,.bmp,.svg,.avif"
                                        (change)="handleLogoUpload($event)"
                                        style="display: none"
                                    />
                                </div>
                                <div
                                    *ngIf="logoPreview"
                                    class="img-preview-container"
                                >
                                    <img
                                        [src]="logoPreview"
                                        alt="Logo preview"
                                        class="img-preview"
                                    />
                                    <button
                                        type="button"
                                        class="btn-remove-img"
                                        *ngIf="!isStepCompleted(1)"
                                        (click)="removeLogo()"
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >What type of business do you have?
                                    <span class="required-mark">*</span></label
                                >
                                <p-dropdown
                                    [options]="businessTypes"
                                    formControlName="businessType"
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder="Select Business Type"
                                    styleClass="w-full"
                                    [disabled]="isStepCompleted(1)"
                                ></p-dropdown>
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessType')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessType')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business type is required
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Tell us about your business
                                    <span class="required-mark">*</span></label
                                >
                                <textarea
                                    pInputTextarea
                                    class="w-full"
                                    rows="4"
                                    placeholder="Describe your business, products/services, and what makes you unique..."
                                    formControlName="businessDescription"
                                    [readonly]="isStepCompleted(1)"
                                ></textarea>
                                <div
                                    *ngIf="
                                        businessDetailsForm.get(
                                            'businessDescription'
                                        )?.invalid &&
                                        businessDetailsForm.get(
                                            'businessDescription'
                                        )?.touched
                                    "
                                    class="error-message"
                                >
                                    Business description is required
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Business Phone Number
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="(555) 123-4567"
                                    formControlName="businessPhone"
                                    (input)="onPhoneInput($event)"
                                    [readonly]="isStepCompleted(1)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('businessPhone')
                                            ?.invalid &&
                                        businessDetailsForm.get('businessPhone')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Business phone number is required
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Street Address
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="123 Main Street"
                                    formControlName="streetAddress"
                                    [readonly]="isStepCompleted(1)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('streetAddress')
                                            ?.invalid &&
                                        businessDetailsForm.get('streetAddress')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Street address is required
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Apartment, Suite, etc. (Optional)</label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="Suite 100, Apt 5B"
                                    formControlName="apartment"
                                    [readonly]="isStepCompleted(1)"
                                />
                            </div>
                            <div class="form-group">
                                <label class="form-label"
                                    >Country
                                    <span class="required-mark">*</span></label
                                >
                                <p-dropdown
                                    [options]="countries"
                                    formControlName="country"
                                    optionLabel="name"
                                    optionValue="name"
                                    placeholder="Select Country"
                                    styleClass="w-full"
                                    [disabled]="isStepCompleted(1)"
                                ></p-dropdown>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label class="form-label"
                                        >City
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <input
                                        pInputText
                                        class="w-full"
                                        placeholder="New York"
                                        formControlName="city"
                                        [readonly]="isStepCompleted(1)"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="form-label"
                                        >State
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <p-dropdown
                                        [options]="usStates"
                                        formControlName="state"
                                        optionLabel="name"
                                        optionValue="code"
                                        placeholder="Select State"
                                        [showClear]="true"
                                        styleClass="w-full"
                                        [disabled]="isStepCompleted(1)"
                                    ></p-dropdown>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >ZIP Code
                                    <span class="required-mark">*</span></label
                                >
                                <input
                                    pInputText
                                    class="w-full"
                                    placeholder="10001"
                                    formControlName="zipCode"
                                    maxlength="5"
                                    inputmode="numeric"
                                    (input)="onZipCodeInput($event)"
                                    [readonly]="isStepCompleted(1)"
                                />
                                <div
                                    *ngIf="
                                        businessDetailsForm.get('zipCode')
                                            ?.invalid &&
                                        businessDetailsForm.get('zipCode')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    ZIP code must be 5 digits
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Preferred Shipping Method
                                    <span class="required-mark">*</span></label
                                >
                                <p-dropdown
                                    [options]="preferredShippingProviderOptions"
                                    formControlName="preferredShippingProvider"
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="Select shipping method"
                                    styleClass="w-full"
                                    [disabled]="isStepCompleted(1)"
                                ></p-dropdown>
                                <div
                                    *ngIf="
                                        businessDetailsForm.get(
                                            'preferredShippingProvider'
                                        )?.invalid &&
                                        businessDetailsForm.get(
                                            'preferredShippingProvider'
                                        )?.touched
                                    "
                                    class="error-message"
                                >
                                    Preferred shipping method is required
                                </div>
                            </div>
                        </form>

                        <div class="actions">
                            <p-button
                                *ngIf="!isStepCompleted(1)"
                                label="Save and Continue"
                                styleClass="cta-btn w-full"
                                (onClick)="validateAndCompleteStep(1)"
                            ></p-button>
                            <p-button
                                *ngIf="isStepCompleted(1)"
                                label="Next Step"
                                styleClass="cta-btn w-full"
                                (onClick)="skipStep(1)"
                            ></p-button>
                        </div>
                    </div>
                </p-accordionTab>

                <p-accordionTab [disabled]="!canOpenStep(2)" *ngIf="showDesignStore">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(2)"
                                >
                                    <i
                                        *ngIf="isStepCompleted(2)"
                                        class="pi pi-check"
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(2)"
                                    >Choose Store Layout</span
                                >
                            </div>
                        </div>
                    </ng-template>

                    <div class="step-content-inner">
                        <p class="helper-text">Choose your store layout.</p>

                        <form [formGroup]="designStoreForm">
                            <div class="form-group">
                                <label class="form-label"
                                    >Store URL
                                    <span class="required-mark">*</span></label
                                >
                                <div class="subdomain-input-group">
                                    <input
                                        pInputText
                                        class="subdomain-input"
                                        placeholder="Store URL"
                                        formControlName="subdomain"
                                        [readonly]="isStepCompleted(2)"
                                    />
                                    <span class="subdomain-extension"
                                        >.lincsell.com</span
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Brand Colors
                                    <span class="required-mark">*</span></label
                                >
                                <p-multiSelect
                                    [options]="brandColorOptions"
                                    formControlName="brandColors"
                                    [disabled]="isStepCompleted(2)"
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="Select brand colors"
                                    selectedItemsLabel="{0} colors selected"
                                    [maxSelectedLabels]="2"
                                    [showToggleAll]="false"
                                    styleClass="w-full"
                                >
                                    <ng-template let-color pTemplate="item">
                                        <div class="brand-color-option">
                                            <span
                                                class="brand-color-swatch"
                                                [class.brand-color-swatch-light]="
                                                    isLightBrandColor(color?.hex)
                                                "
                                                [style.background]="color?.hex"
                                            ></span>
                                            <span class="brand-color-option-label">{{
                                                color?.name
                                            }}</span>
                                        </div>
                                    </ng-template>
                                    <ng-template let-value pTemplate="selectedItems">
                                        <div
                                            class="brand-color-selected-list"
                                            *ngIf="value?.length; else brandColorPlaceholder"
                                        >
                                            <span
                                                class="brand-color-selected-chip"
                                                *ngFor="let code of value"
                                            >
                                                <span
                                                    class="brand-color-swatch"
                                                    [class.brand-color-swatch-light]="
                                                        isLightBrandColor(
                                                            getBrandColorOption(code)?.hex
                                                        )
                                                    "
                                                    [style.background]="
                                                        getBrandColorOption(code)?.hex
                                                    "
                                                ></span>
                                                <span>{{
                                                    getBrandColorOption(code)?.name
                                                }}</span>
                                            </span>
                                        </div>
                                        <ng-template #brandColorPlaceholder>
                                            <span class="brand-color-placeholder"
                                                >Select brand colors</span
                                            >
                                        </ng-template>
                                    </ng-template>
                                </p-multiSelect>
                                <div
                                    *ngIf="
                                        designStoreForm.get('brandColors')
                                            ?.invalid &&
                                        designStoreForm.get('brandColors')
                                            ?.touched
                                    "
                                    class="error-message"
                                >
                                    Please select at least one brand color
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="form-label"
                                    >Select a Layout Theme
                                    <span class="required-mark">*</span></label
                                >
                                <div class="theme-grid">
                                    <div
                                        class="theme-card"
                                        *ngFor="let theme of themesToDisplay"
                                        [class.locked]="isStepCompleted(2)"
                                        [class.selected]="
                                            selectedTheme?.templateID ===
                                            theme.templateID
                                        "
                                        (click)="requestThemeSelection(theme)"
                                    >
                                        <div
                                            class="theme-preview"
                                            [ngClass]="
                                                getTemplatePreviewClass(theme)
                                            "
                                        >
                                            <img
                                                [src]="getThemePreviewImage(theme)"
                                                alt="{{ theme.name }} Preview"
                                                class="theme-image"
                                                loading="lazy"
                                                referrerpolicy="no-referrer"
                                                (error)="onThemePreviewError($event)"
                                            />
                                        </div>
                                        <div class="theme-info">
                                            <span class="theme-name">{{
                                                theme.name ?? ""
                                            }}</span>
                                            <a
                                                class="theme-demo-link"
                                                [href]="theme.demoUrl"
                                                target="_blank"
                                                rel="noopener"
                                                (click)="$event.stopPropagation()"
                                                >View Demo &rarr;</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="actions">
                            <p-button
                                *ngIf="!isStepCompleted(2)"
                                label="Save and Continue"
                                styleClass="cta-btn w-full"
                                (onClick)="validateAndCompleteStep(2)"
                            ></p-button>
                            <p-button
                                *ngIf="isStepCompleted(2)"
                                label="Next Step"
                                styleClass="cta-btn w-full"
                                (onClick)="skipStep(2)"
                            ></p-button>
                        </div>
                    </div>
                </p-accordionTab>



                
                <p-accordionTab [disabled]="!canOpenStep(3)" *ngIf="showAddProducts">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(3)"
                                >
                                    <i
                                        *ngIf="isStepCompleted(3)"
                                        class="pi pi-check"
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(3)"
                                    >Add Inventory</span
                                >
                            </div>
                        </div>
                    </ng-template>

                    <div class="step-content-inner">
                        <label class="form-label form-label-lg"
                            >{{ hasAddedProducts ? 'Add More Products' : 'Add Products' }}
                            <span class="required-mark">*</span></label
                        >
                        <p class="helper-text" *ngIf="hasAddedProducts">
                            You already added a product. You can add more products below or continue to the next step.
                        </p>

                        <div class="inventory-choice" *ngIf="!hasAddedProducts">
                            <button
                                type="button"
                                class="inventory-mode-btn"
                                [class.active]="inventoryMode === 'add_products'"
                                (click)="setInventoryMode('add_products')"
                            >
                                Add Products
                            </button>
                            <button
                                type="button"
                                class="inventory-mode-btn"
                                [class.active]="inventoryMode === 'dont_have'"
                                (click)="setInventoryMode('dont_have')"
                            >
                                I don't have
                            </button>
                        </div>

                        <div *ngIf="inventoryMode === 'add_products'">
                            <form [formGroup]="addProductsForm">
                                <div class="form-group">
                                    <label class="form-label"
                                        >Product Name
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <input
                                        type="text"
                                        pInputText
                                        class="w-full"
                                        placeholder="e.g. Summer T-Shirt"
                                        formControlName="productName"
                                    />
                                    <div
                                        *ngIf="
                                            addProductsForm.get('productName')
                                                ?.invalid &&
                                            addProductsForm.get('productName')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        Product name is required
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label"
                                        >Category
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <input
                                        type="text"
                                        pInputText
                                        class="w-full"
                                        placeholder="e.g. Clothing"
                                        formControlName="productCategory"
                                    />
                                    <div
                                        *ngIf="
                                            addProductsForm.get('productCategory')
                                                ?.invalid &&
                                            addProductsForm.get('productCategory')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        Category is required
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label"
                                        >Description
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <textarea
                                        pInputTextarea
                                        class="w-full"
                                        rows="3"
                                        placeholder="Describe your product..."
                                        formControlName="productDescription"
                                    ></textarea>
                                    <div
                                        *ngIf="
                                            addProductsForm.get(
                                                'productDescription'
                                            )?.invalid &&
                                            addProductsForm.get(
                                                'productDescription'
                                            )?.touched
                                        "
                                        class="error-message"
                                    >
                                        Description is required
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label"
                                        >Price ($)
                                        <span class="required-mark">*</span
                                        ></label
                                    >
                                    <p-inputNumber
                                        mode="currency"
                                        currency="USD"
                                        locale="en-US"
                                        placeholder="0.00"
                                        formControlName="productPrice"
                                        styleClass="w-full"
                                        class="w-full"
                                    ></p-inputNumber>
                                    <div
                                        *ngIf="
                                            addProductsForm.get('productPrice')
                                                ?.invalid &&
                                            addProductsForm.get('productPrice')
                                                ?.touched
                                        "
                                        class="error-message"
                                    >
                                        Price must be greater than 0
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label"
                                        >Product Image</label
                                    >
                                    <p class="helper-text-small">
                                        Recommended size: 800x800px or larger.
                                        Supported formats: JPG, PNG, GIF.
                                        Maximum file size: 5MB.
                                    </p>
                                    <div
                                        *ngIf="!imgPreview"
                                        class="upload-btn-wrapper"
                                    >
                                        <button
                                            type="button"
                                            class="btn-upload"
                                            (click)="fileInput.click()"
                                        >
                                            <i class="pi pi-upload"></i>
                                            Upload Image
                                        </button>
                                        <input
                                            #fileInput
                                            type="file"
                                            accept="image/*"
                                            (change)="handleImageUpload($event)"
                                            style="display: none"
                                        />
                                    </div>
                                    <div
                                        *ngIf="imgPreview"
                                        class="img-preview-container"
                                    >
                                        <img
                                            [src]="imgPreview"
                                            alt="Preview"
                                            class="img-preview"
                                        />
                                        <button
                                            type="button"
                                            class="btn-remove-img"
                                            (click)="removeImage()"
                                        >
                                            ×
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <div class="actions">
                                <p-button
                                    [label]="hasAddedProducts ? 'Save Another Product' : 'Save Product'"
                                    styleClass="cta-btn w-full"
                                    (onClick)="completeStep(3)"
                                ></p-button>
                                <p-button
                                    *ngIf="hasAddedProducts"
                                    [label]="showStoreContent ? 'Skip' : 'Complete Setup'"
                                    styleClass="cta-btn w-full mt-2"
                                    (onClick)="continueAfterInventory()"
                                ></p-button>
                            </div>
                        </div>

                        <div *ngIf="inventoryMode === 'dont_have'">
                            <p class="helper-text">
                                We will use some dummy products related to your
                                business to set-up the online store.
                            </p>
                            <div class="actions">
                                <p-button
                                    label="Save and Continue"
                                    styleClass="cta-btn w-full"
                                    (onClick)="completeInventoryWithoutProducts()"
                                ></p-button>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>

                <p-accordionTab [disabled]="!canOpenStep(4)" *ngIf="showStoreContent">
                    <ng-template pTemplate="header">
                        <div class="step-header-content">
                            <div class="step-left">
                                <div
                                    class="icon-box"
                                    [class.completed]="isStepCompleted(4)"
                                >
                                    <i
                                        *ngIf="isStepCompleted(4)"
                                        class="pi pi-check"
                                    ></i>
                                </div>
                                <span
                                    class="step-text"
                                    [class.text-completed]="isStepCompleted(4)"
                                    >Add Store Content</span
                                >
                            </div>
                        </div>
                    </ng-template>

                    <div class="step-content-inner">
                        <p class="helper-text">
                            Please download the store content file, complete the
                            required information, and upload it via your
                            dashboard or email once finished.
                        </p>

                        <div class="actions actions-gap-sm">
                            <button
                                type="button"
                                class="ghost-action-btn"
                                (click)="downloadStoreContentTemplate()"
                            >
                                Download Store Content File
                            </button>

                            <p-button
                                label="Continue"
                                styleClass="cta-btn w-full"
                                (onClick)="continueFromStoreContent()"
                            ></p-button>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>

        <div *ngIf="isSuccess" class="success-view">
            <div class="checkmark-circle">
                <i
                    class="pi pi-check"
                    style="font-size: 32px; font-weight: bold"
                ></i>
            </div>
            <h2>You are all set</h2>
            <p>Your store is configured and ready.</p>
            <div class="actions mt-4">
                <p-button
                    label="Explore Dashboard"
                    styleClass="cta-btn w-full mt-2"
                    (onClick)="goToDashboard()"
                ></p-button>
            </div>
            <p *ngIf="isCountingDown" class="text-center text-muted mt-3">
                Redirecting to dashboard in {{ redirectCountdown }} seconds...
            </p>
        </div>
    </div>
</div>
<p-dialog
    [(visible)]="showLayoutConfirmDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [dismissableMask]="true"
    [style]="{ width: '560px', maxWidth: '92vw' }"
    styleClass="layout-confirm-dialog"
>
    <div class="layout-confirm-content">
        <p>
            Please choose your template carefully, as it will be used to setup
            your online store and cannot be changed once selected.
        </p>
        <div class="layout-confirm-actions">
            <button
                type="button"
                class="inventory-mode-btn"
                (click)="dismissLayoutConfirmation()"
            >
                Discard
            </button>
            <button
                type="button"
                class="inventory-mode-btn active"
                (click)="confirmLayoutSelection()"
            >
                Continue
            </button>
        </div>
    </div>
</p-dialog>
</div>

